<template>
  <ValidationProvider
    v-slot="{ valid, errors }"
    :vid="vid"
    :name="$attrs.name"
    :rules="rules"
    :disabled="disabled"
  >
    <b-form-group v-bind="$attrs">
      <b-input-group v-bind="$attrs">
        <b-form-textarea
          v-if="isTextArea"
          v-model="innerValue"
          v-bind="$attrs"
          :disabled="disabled"
          :min="min"
          :max="max"
          :state="errors[0] ? false : valid ? true : null"
        />
        <b-form-input
          v-else
          v-model="innerValue"
          v-bind="$attrs"
          :disabled="disabled"
          :min="min"
          :max="max"
          :state="errors[0] ? false : valid ? true : null"
        />
        <b-form-invalid-feedback id="inputLiveFeedback">
          {{ errors[0] }}
        </b-form-invalid-feedback>
      </b-input-group>
    </b-form-group>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import ValidationMixins from "@/mixins/validationMixin";

export default {
  components: {
    ValidationProvider,
  },
  mixins: [ValidationMixins],
  props: {
    vid: {
      type: String,
      default: "",
    },
    rules: {
      type: [Object, String],
      default: "",
    },
    // must be included in props
    value: {
      type: null,
      default: null,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isTextArea: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    innerValue: {
      get() {
        return this.value;
      },

      set(newval) {
        this.$emit("input", newval);
      },
    },
  },
};
</script>
